import React, { useState } from 'react'

import { Button, Grid } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import { Container, ContentHeader, DriveTour, Page } from 'components'
import { Filters, SuggestionTable } from './components'

import useFilter from 'hooks/useFilter'

import constants from 'constants/index'
import inviteStreamlineIcon from 'images/invite_streamline_icon.svg'
import useStyles from './styles'

const ThirdPartyManagementSuggestion = () => {
  const [openTour, setOpenTour] = useState(false)

  const filter = useFilter()
  const classes = useStyles()

  const handleOpenTour = () => setOpenTour(true)

  return (
    <Page title="Gestão de Fornecedores - Sugestões">
      <Container maxWidth={false}>
        <ContentHeader title="Sugestões">
          <Button
            id={constants.tours.thirdPartyManagements.STEPS.SUGGESTIONS[1]}
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
          >
            Tutorial
          </Button>

          <Filters filter={filter} />
        </ContentHeader>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Alert
              severity="info"
              className={classes.alert}
              icon={
                <img
                  src={inviteStreamlineIcon}
                  alt=""
                  width={32}
                  height={32}
                  className={classes.alertIcon}
                />
              }
            >
              {constants.thirdPartyManagements.BANNERS.PARTNER}
            </Alert>
          </Grid>

          <Grid item xs={12}>
            <SuggestionTable filter={filter} />
          </Grid>
        </Grid>
      </Container>
      <DriveTour
        stepsMatrix={
          constants.tours.thirdPartyManagements.STEPS_OBJECT.SUGGESTIONS
        }
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default ThirdPartyManagementSuggestion
